import composeReducers from '../composeReducers';
import smap from './smap';
import smapReverse from './smapReverse';
export default composeReducers(smap ,smapReverse) ;
